const obMainCartState = {
	gtm: {
		queue: []
	}
};


function obMainCartHandleGTM(key, options) {
	let targetItem = null;
	const lineItems = document.querySelectorAll('#line-item-product');
	const items = Array.from(lineItems).map((lineItem) => {
		const rawDetails = lineItem.getAttribute('data-lineitemdetails');
		const details = JSON.parse(rawDetails);
		if (details.final_price === 0) {
			details.price = 0;
		}
		if (options.targetId === details.id) {
			targetItem = { ...details, quantity: options.quantityDiff };
			details.quantity = options.newQuantity;
			if (details.quantity <= 0) {
				return null;
			}
		}
		const rawCategories = lineItem.getAttribute('data-lineitemcategories');
		const { collections: categories } = JSON.parse(rawCategories);
		return { ...details, categories };
	});

	const filteredItems = items.filter((item) => !!item);
	document.dispatchEvent(new CustomEvent(
		key,
		{
			bubbles: true,
			detail: {
				cart: { items: filteredItems },
				item: targetItem
			}
		}
	));
}

// eslint-disable-next-line no-unused-vars
function handleQuantitySelectorMinus(targetId, quantity) {
	obMainCartHandleGTM('cart:remove', { targetId, oldQuantity: quantity + 1, newQuantity: quantity, quantityDiff: 1 });
}

// eslint-disable-next-line no-unused-vars
function handleQuantitySelectorPlus(targetId, quantity) {
	obMainCartHandleGTM('cart:add', { targetId, oldQuantity: quantity - 1, newQuantity: quantity, quantityDiff: 1 });
}

// eslint-disable-next-line no-unused-vars
function handleRemoveItem(targetId, quantity) {
	obMainCartHandleGTM('cart:remove', { targetId, oldQuantity: quantity, newQuantity: 0, quantityDiff: quantity });
}

// eslint-disable-next-line no-unused-vars
function handleQuantityInputChange(event) {
	const { target } = event;
	const targetId = Number(target.getAttribute('data-itemlineid'));
	const oldQuantity = Number(target.defaultValue);
	const newQuantity = Number(target.value);
	if (newQuantity > oldQuantity) {
		obMainCartHandleGTM('cart:add', { targetId, oldQuantity, newQuantity, quantityDiff: newQuantity - oldQuantity });
		return;
	}
	if (newQuantity < oldQuantity) {
		obMainCartHandleGTM('cart:remove', { targetId, oldQuantity, newQuantity, quantityDiff: oldQuantity - newQuantity });
	}
}

const obMainCartInputs = document.querySelectorAll('#quantity-selector-input');
obMainCartInputs.forEach((input) => {
	input.onchange = handleQuantityInputChange;
});

const obMainCartHandleCheckout = () => {
	const lineItems = document.querySelectorAll('#line-item-product');
	const items = Array.from(lineItems).map((lineItem) => {
		const rawDetails = lineItem.getAttribute('data-lineitemdetails');
		const details = JSON.parse(rawDetails);
		// Rule: Gifts should have price equals zero
		const isGift = details.final_price === 0;
		if (isGift) {
			details.price = 0;
		}
		const rawCategories = lineItem.getAttribute('data-lineitemcategories');
		const { collections: categories } = JSON.parse(rawCategories);
		return { ...details, categories };
	});
	const step = 1;
	const stepName = 'cart';
	if(!window.gtmHandler) {
		obMainCartState.gtm.queue.push(()=> {
			window.gtmHandler.enhancedEcommerce.checkout(step, stepName, items);
		});
		return;
	}
	window.gtmHandler.enhancedEcommerce.checkout(step, stepName, items);
};

const disableMiniCart = () => {
	const miniCart = document.querySelector('.ob-header-mini-cart');
	miniCart.setAttribute('href', '#');
};

const obMainCartHandleGift = () => {
	// Note: Handle added gift
	const rawAddedGift = sessionStorage.getItem('ob-main-cart-offer-mark');
	if (rawAddedGift) {
		const addedGift = JSON.parse(rawAddedGift);
		sessionStorage.removeItem('ob-main-cart-offer-mark');
		const rawLineItems = document.querySelectorAll('[data-lineitemdetails]');
		const details = Array.from(rawLineItems).map((rawLineItem) => {
			const rawDetails = rawLineItem.getAttribute('data-lineitemdetails');
			if (rawDetails) {
				return JSON.parse(rawDetails);
			}
		});
		const itemDetails = details.find((element) => element.product_title === addedGift.title);
		if (itemDetails) {
			document.dispatchEvent(new CustomEvent(
				'cart:add',
				{
					bubbles: true,
					detail: {
						item: { ...itemDetails , price: 0 }
					}
				}
			));
		}
	}
	
	// Note: Handle add Gift button click
	const handleGiftAdd = (giftOffer) => {
		const addGiftButton = giftOffer.querySelector('[name="add"]');
		if (!addGiftButton) {
			// eslint-disable-next-line no-console
			console.error('Add gift button not found.');
			return;
		}
		addGiftButton.addEventListener('click', () => {
			// Id
			const offerId = giftOffer.getAttribute('data-offerid');
			// Title
			let offerTitle = undefined;
			const rawOfferTitle = giftOffer.querySelector('.offer-text');
			if (rawOfferTitle) {
				offerTitle = rawOfferTitle.textContent;
			}
			const offer = {
				id: offerId,
				title: offerTitle,
			};
			sessionStorage.setItem('ob-main-cart-offer-mark', JSON.stringify(offer));
		});
	};

	// Note: Try to find gift offers
	const limit = 5;
	let attempts = 1;
	const findOffer = () => {
		setTimeout(() => {
			attempts ++;
			const giftOffer = document.querySelector('[data-offerid]');
			if (!giftOffer) {
				if (attempts <= limit) {
					findOffer();
				}
				return;
			}
			handleGiftAdd(giftOffer);
		}, 500 * attempts);
	};
	findOffer();
};

document.addEventListener('DOMContentLoaded', () => {
	obMainCartHandleCheckout();
	disableMiniCart();
	obMainCartHandleGift();
});

document.addEventListener('gtm-handler:loaded',() => {
	if(obMainCartState.gtm.queue.length > 0) {
		obMainCartState.gtm.queue.forEach((event)=> event.call());
		obMainCartState.gtm.queue = [];
	}
});
